import styled from 'styled-components';
import { focusVisibleMixin } from '@elfsight/widget-ui';
import { useSettings } from '@wu/widget-core';
import { Icon } from '../../../common';
import { useData } from './DataProvider';

export function Info() {
  const {
    metadata: { name, caption, icon }
  } = useData();
  const {
    showMenuIcon,
    menuTitleFontStyle: { fontSize },
    accentColor
  } = useSettings();

  const iconSize = fontSize * 1.333;
  const iconColor = accentColor || '#111';

  return (
    <Component>
      <InfoTitle>
        {showMenuIcon && icon && (
          <Icon
            icon={icon}
            size={iconSize}
            fill={iconColor}
            style={{ marginRight: name ? '12px' : '0px' }}
            alt=""
          />
        )}

        {name}
      </InfoTitle>

      {caption && (
        <InfoCaption
          dangerouslySetInnerHTML={{
            __html: caption
          }}
        />
      )}
    </Component>
  );
}

export const InfoCaption = styled.div`
  margin-top: 8px;
  font-size: ${({
    theme: {
      menuCaptionFontSize: { fontSize }
    }
  }) => fontSize}px;
  line-height: 1.5;
  color: #111111;
  opacity: 0.65;
  text-align: center;

  & a {
    ${focusVisibleMixin()}
  }
`;

const Component = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
export const InfoTitle = styled.div`
  font-size: ${({
    theme: {
      menuTitleFontStyle: { fontSize }
    }
  }) => fontSize}px;
  font-weight: ${({
    theme: {
      menuTitleFontStyle: { fontWeight }
    }
  }) => fontWeight};
  line-height: 1.33;
  position: relative;
  display: flex;
  align-items: center;
  text-align: center;
  text-transform: ${({
    theme: {
      menuTitleFontStyle: { textTransform }
    }
  }) => textTransform};

  &::before {
    content: '';
    position: absolute;
    width: 1200px;
    height: 2px;
    top: 50%;
    right: calc(100% + 24px);
  }

  &::after {
    content: '';
    position: absolute;
    width: 1200px;
    height: 2px;
    top: 50%;
    left: calc(100% + 24px);
  }
`;
